/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { Component } from 'react';
import {
    object, string, func, shape, arrayOf,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CgcEditor from '../../RTE/CgcEditor';

const styles = (theme) => ({
    messageContent: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        resize: 'none',
        padding: '15px 5px',
        fontSize: 16,
        border: 'none',
        overflow: 'hidden',
    },
    textEditor: {
        position: 'absolute',
        zIndex: 1000,
        right: 10,
        top: 150,
        [theme.breakpoints.down('sm')]: {
            left: 'unset',
            bottom: 115,
            right: 40,
            top: 'unset',
        },
        [theme.breakpoints.down('xs')]: {
            right: 'unset',
            top: 'unset',
            left: 'unset',
            bottom: 80,
        },
    },
    messageWrapper: {
        width: '100%',
        height: '100%',

    },
});
class CustomsMessageView extends Component {
    constructor(props) {
        super(props);
        const { csLabelData, messageData } = this.props;
        let existingStyles = {};
        if (messageData?.style) {
            existingStyles = messageData.style;
        }

        this.state = {
            text: '',
            style: {
                fontSize: `${csLabelData?.message_settings?.heading_font_size}px`,
                ...existingStyles,
            },
            showTextEditor: false,
            fontLimit: null,
        };
    }

    componentDidMount() {
        const { messageData, toolbarProps, customCardType } = this.props;
        const fontFamliyData = toolbarProps?.filter((item) => item?.value === 'font');
        const font = fontFamliyData?.[0]?.list?.[0];
        const fontLimit = customCardType === 'text' ? font?.maxChar : (font?.maxChar / 3);
        this.setState({ fontLimit, style: { fontFamily: messageData?.style?.fontFamily || font?.value } });
        if (messageData?.text) {
            this.setState({
                text: messageData?.text,
                style: messageData?.style,
            });
        }
    }

    handleTextEditor = (val) => {
        this.setState({ showTextEditor: val });
    }

    updateMessageData = () => {
        const { text, style } = this.state;
        const { setCardMessage } = this.props;
        const messageData = {
            style, text,
        };
        setCardMessage(messageData);
    }

    handleChange = (e) => {
        this.setState({
            text: e.target.value,
        }, () => this.updateMessageData());
    };

    handleStyle = (style) => {
        const { toolbarProps, customCardType } = this.props;
        const { text } = this.state;
        const fontFamliyData = toolbarProps?.filter((item) => item?.value === 'font');
        const font = fontFamliyData?.[0]?.list?.filter((fontData) => fontData?.value === style.fontFamily);
        const controlledText = text?.substr(0, font?.[0]?.maxChar);
        const fontLimit = customCardType === 'text' ? font?.[0]?.maxChar : (font?.[0]?.maxChar / 3);
        this.setState({
            style, fontLimit, text: controlledText,
        }, () => this.updateMessageData());
    }

    renderEditor = () => {
        const { classes, toolbarProps } = this.props;
        const { style } = this.state;
        return (
            <Grid className={classes.textEditor}>
                <CgcEditor
                    style={style}
                    handleStyle={this.handleStyle}
                    toolbarProps={toolbarProps}
                />
            </Grid>
        );
    }

    render() {
        const { classes, csLabelData } = this.props;
        const {
            text, style, showTextEditor, fontLimit,
        } = this.state;
        return (
            <>
                <Grid className={classes.messageWrapper}>
                    <textarea
                        className={classes.messageContent}
                        placeholder="Enter Text Here"
                        value={text}
                        style={{ ...style, fontSize: `${csLabelData?.message_settings?.heading_font_size}pt` }}
                        maxLength={fontLimit}
                        onChange={(e) => this.handleChange(e)}
                        onFocus={() => this.handleTextEditor(true)}
                    />
                </Grid>
                {showTextEditor
                && this.renderEditor()}

            </>
        );
    }
}
CustomsMessageView.propTypes = {
    classes: object.isRequired,
    messageData: object.isRequired,
    setCardMessage: func.isRequired,
    csLabelData: shape({
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    toolbarProps: arrayOf(shape({
        value: string,
        label: string,
        icon: object,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
    customCardType: string.isRequired,
};
CustomsMessageView.defaultProps = {
    toolbarProps: {},
};
export default withStyles(styles)(CustomsMessageView);
